import { AxiosInstance } from 'axios';
import { ITextLinkToDownloadAppRequestBody, sendText } from '../api';
import { BaseComponentPropsType } from '../BrandclubLanding/type';
import { buildTrackingParams } from './analytics';
import { AnalyticsTrackingEvent } from '../analytics';

export const sendTextCallback = async (
  phoneNumber: string,
  axios: AxiosInstance,
  mainEntity: BaseComponentPropsType['mainEntity'],
  analyticsTrack: BaseComponentPropsType['analyticsTrack'],
  trackingParams: BaseComponentPropsType['trackingParams'],
  trackingEventName: AnalyticsTrackingEvent,
) => {
  const queryParams = buildTrackingParams({ trackingParams, mainEntity });
  const sourceMetaData: ITextLinkToDownloadAppRequestBody['sourceMetaData'] = {};
  if (mainEntity?.type === 'product') {
    sourceMetaData.sku = mainEntity?.entity.stacklineSku;
    sourceMetaData.brandId = mainEntity?.entity.brandId;
  } else if (mainEntity?.type === 'brand') {
    sourceMetaData.brandId = parseInt(`${mainEntity?.id}`);
  }
  const result = await sendText(axios, {
    phoneNumber,
    queryParams,
    source:
      mainEntity?.type === 'product'
        ? 'productLandingPage'
        : mainEntity?.type === 'brand'
        ? 'brandLandingPage'
        : 'outerPage',
    sourceMetaData,
  });
  if (analyticsTrack) {
    analyticsTrack(trackingEventName, {
      ...queryParams,
      phoneNumber,
    });
  }
  return result;
};
